import React from 'react';
import { SimpleForm, Edit, TextInput, BooleanInput } from 'react-admin';
import { required } from 'ra-core';
import { NameTitle } from '../../utils/Title.component';
import ScreenDescription from '../ScreenDescription';
import SaveOnlyToolbar from '../SaveOnlyToolbar';
import CostHistory from './CostHistory';

const MessageTypeEdit = props => (
  <>
    <ScreenDescription>
      "Vigente a partir de" define quando o novo custo passa a valer — nunca sobrescreve uma vigência já existente. É esse valor
      que a tela de Volumetria usa pra calcular o custo de cada mensagem, sempre com o preço que estava valendo na data em que
      ela foi enviada. Não existe exclusão de tipo — só desativação.
    </ScreenDescription>
    <Edit {...props} title={<NameTitle model="Tipo de mensagem" record={props} />}>
      <SimpleForm toolbar={<SaveOnlyToolbar />}>
        <TextInput source="name" label="Nome" validate={required()} />
        <TextInput source="key" label="Chave" validate={required()} />
        <BooleanInput source="active" label="Ativo" />
        <CostHistory />
      </SimpleForm>
    </Edit>
  </>
);

export default MessageTypeEdit;
